export default "__VITE_ASSET__83aceaef__"